import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import ClaimLogViewTableRow from './ClaimLogViewTableRow';

const styles = theme => ({
  root: {
    minHeight: 300,
    overflow: 'hidden',
  },
  table: {
    minWidth: 500,
  },
  tableHead: {
    '& th:first-child': {
      borderTopLeftRadius: 10,
    },
    '& th:last-child': {
      borderTopRightRadius: 10,
    },
  },
  cellCount: {
    paddingRight: 0,
  },
});

const ClaimLogViewTable = ({
  Claim,
  Insurance,
  business,
  variant,
  classes,
}) => (
  <div className={classes.root}>
    <Table className={classes.table}>
      <TableHead className={classes.tableHead}>
        <TableRow>
          <TableCell className={classes.cellCount}>
            Lines
          </TableCell>
          <TableCell>Submitted</TableCell>
          <TableCell>Claim Status</TableCell>
          {variant === 'order' &&
            <TableCell>HCPCS</TableCell>
          }
          <TableCell>Date Of Service</TableCell>
          <TableCell>Insurance</TableCell>
          <TableCell>Charge</TableCell>
          <TableCell>Amount Paid</TableCell>
          <TableCell>Claim #</TableCell>
          <TableCell>Check Number</TableCell>
          <TableCell>Paid Date</TableCell>
          <TableCell>User</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {Claim.map(item => (
          <ClaimLogViewTableRow
            key={item.ID}
            {...item}
            Insurance={Insurance}
            business={business}
            variant={variant}
          />
        ))}
      </TableBody>
    </Table>
  </div>
);

ClaimLogViewTable.propTypes = {
  variant: PropTypes.oneOf(['order', 'order-line']),
  Claim: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
    'Claim Status': PropTypes.string,
    'Create At': PropTypes.string,
  })).isRequired,
  Insurance: PropTypes.shape({
    ID: PropTypes.number.isRequired,
  }),
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    table: PropTypes.string.isRequired,
    tableHead: PropTypes.string.isRequired,
    cellCount: PropTypes.string.isRequired,
  }).isRequired,
};

ClaimLogViewTable.defaultProps = {
  Insurance: [],
  business: {},
  variant: 'order-line',
};

export default withStyles(styles)(ClaimLogViewTable);



// WEBPACK FOOTER //
// ./src/components/workflow/ClaimLogViewDialog/ClaimLogViewTable.js